import { all } from 'redux-saga/effects'

import mainSaga from './main'
import searchSaga from './search'
import detailsSaga from './contact_details'
import importSaga from './import'

export default function* contactManagementSaga() {
  yield all([
    mainSaga(),
    searchSaga(),
    detailsSaga(),
    importSaga()
  ])
}
